import { render, staticRenderFns } from "./humancloud.vue?vue&type=template&id=55df446c&scoped=true"
import script from "./humancloud.vue?vue&type=script&lang=js"
export * from "./humancloud.vue?vue&type=script&lang=js"
import style0 from "./humancloud.vue?vue&type=style&index=0&id=55df446c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55df446c",
  null
  
)

export default component.exports